export const api = {
  queryReceiveReportList: "/bms/manage/reportEvent/queryPage.json", //接单管理查询
  queryEventTaskPage: "/bms/manage/reportEvent/queryEventTaskPage.json", //任务派单查询
  getDeviceType: '/bms/device/queryDeviceTypeCount.json', //查询设备类型
  getDeviceList: '/bms/device/getDeviceListByPage.json', //查询所有设备
  reportEvent: '/bms/manage/reportEvent/handleEvent.json', //处置事件
  addReport: '/bms/manage/reportEvent/report.json', //上报事件
  queryAllPerson: '/cms/account/queryResultsByPag.json', //查询人员
  deleteData: '/bms/manage/reportEvent/delete.json', //删除数据
};
